// src/pages/ArtifactsPage.tsx
// Artifacts page - placeholder for future implementation

import React from 'react';
import Sidebar from '../components/Sidebar';
import ThemeToggle from '../components/ThemeToggle';
import { getRandomTagline } from '../utils/taglines';

const ArtifactsPage: React.FC = () => {
  return (
    <div className="flex flex-col h-screen bg-background text-foreground overflow-hidden">
      {/* Header */}
      <header className="flex-shrink-0 border-b border-border bg-card/50 backdrop-blur-sm">
        <div className="flex items-center justify-between px-6 py-4">
          <div className="flex items-center space-x-4">
            <img
              src="/cubemate-logo.png"
              alt="Cubemate"
              className="w-10 h-10 rounded-lg"
            />
            <div>
              <div className="flex items-center space-x-2">
                <h1 className="text-xl font-bold bg-gradient-to-r from-primary to-brand bg-clip-text text-transparent">
                  Cubemate
                </h1>
              </div>
              <p className="text-xs text-muted-foreground/80 font-normal italic">
                {getRandomTagline()}
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <ThemeToggle />
          </div>
        </div>
      </header>

      {/* Body: Sidebar + Main Content */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <Sidebar />

        {/* Main Content Area */}
        <div className="flex-1 flex items-center justify-center p-8">
          <div className="text-center max-w-2xl">
            <h1 className="text-4xl font-bold text-foreground mb-4">Artifacts</h1>
            <p className="text-muted-foreground text-lg">
              Coming soon...
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArtifactsPage;
